import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SummaryOfTheYearData } from '@agilox/common';
import { SummaryOfTheYearVehicleData } from '@agilox/common';
import { DistancePipe } from '@agilox/common';
import { WeightPipe } from '@agilox/common';
import { SummaryOfTheYearService } from '@agilox/common';
import { CustomNumberPipe } from '@agilox/pipe/custom-number';
import { ButtonComponent } from '@agilox/ui';
import { SummaryDownloadPageComponent } from '../summary-download-page/summary-download-page.component';
import { SummaryNavigationComponent } from '../summary-navigation/summary-navigation.component';
import { SummaryOverviewLabelComponent } from '../summary-overview-label/summary-overview-label.component';
import { SummaryStartPageComponent } from '../summary-start-page/summary-start-page.component';
import { SecondsPipe } from '@agilox/pipe/seconds';

@Component({
	selector: 'single-vehicle',
	templateUrl: './single-vehicle.component.html',
	imports: [
		SummaryNavigationComponent,
		ButtonComponent,
		CustomNumberPipe,
		DistancePipe,
		WeightPipe,
		TranslatePipe,
		SecondsPipe,
		SummaryDownloadPageComponent,
		SummaryOverviewLabelComponent,
		SummaryStartPageComponent,
	],
})
export class SingleVehicleComponent implements OnInit {
	private readonly summaryService = inject(SummaryOfTheYearService);

	year = input<number>();
	data = input.required<SummaryOfTheYearData>();

	vehicleData = computed<SummaryOfTheYearVehicleData>(() => {
		return Object.values(this.data())[0];
	});

	currentSlideIndex = signal(0);
	private swiper: ReturnType<typeof setInterval> | null = null;

	ngOnInit() {
		this.swiper = setInterval(() => this.nextSlide(), 3000);
	}

	nextSlide(): void {
		if (this.currentSlideIndex() < this.totalSlides - 1) {
			this.currentSlideIndex.set(this.currentSlideIndex() + 1);
		} else {
			if (this.swiper !== null) {
				clearInterval(this.swiper);
				this.swiper = null;
			}
		}
	}

	protected readonly totalSlides = 6;

	closeSummary(): void {
		this.summaryService.closeSummary();
		this.currentSlideIndex.set(0);
	}
}
